import Tls from "@/services/Tls";
import TlsCasesList from "@/components/TlsCase/List";

// ==================
// NAME
// ==================
const name = "TlsCaseIndex";

// ==================
// DATA
// ==================
const data = function () {
	return {
		totalPage:   1,
		currentPage: 1,
		loaded:      false,
		filter:      null,
		tlsCases:    [],
	};
};

const indexPage = function () {
	return this.$route.name === "tlsCaseIndex";
};

const fetchData = function () {
	const { query: { limit = 15, page }, params: { scope } } = this.$route;
	
	this.loaded = false;
	this.filter = scope;

	const caseService = this.indexPage() ? fetchAll : fetchMine;

	caseService.bind(this)({ scope, limit, page }).then(response => {
		this.tlsCases  = response.cases || [];
		this.totalPage = Math.ceil(response.total_count / limit);
		this.loaded    = true;
		
		window.scroll(0, 0);
	});

	this.currentPage = page ? Number.parseInt(page) : 1;
};

const fetchAll = function ({ scope, limit, page }) {	
	return Tls.Cases.allSharded({ scope, limit, page }).then(responses => ( {
		cases: 				responses.flatMap(response => response.cases).filter(Boolean),
		total_count: 	Math.max(...responses.flatMap(({ total_count }) => total_count))
	}));
};

const fetchMine = function ({ scope, limit, page }) {	
	return Tls.Cases.mineSharded({ scope, limit, page }).then(responses => ( {
		cases: 				responses.flatMap(response => response.cases).filter(Boolean),
		total_count: 	Math.max(...responses.flatMap(({ total_count }) => total_count))
	}));
};

const removeCaseFromList = function(tlsCase) {
	const data     = Object.assign([], this.tlsCases);
	this.tlsCases  = data.filter(c => c != tlsCase);
};

export default {
	name,
	data,

	watch: {
		"$route": "fetchData"
	},

	components: {
		TlsCasesList
	},

	methods: {
		indexPage,
		fetchData,
		removeCaseFromList,
		linkGen(pageNum) {
		 	return pageNum === 1 ? "?" : `?page=${pageNum}`;
		}
	},

	mounted() {
		this.fetchData();
	}
};